import { EMAIL_MAX_LENGTH, normalizeEmail } from '@gozoki/tools'
import vine, { type VineString } from '@vinejs/vine'

/**
 * `normalizeEmail` de validator.js active par défaut des réécritures propres à
 * certains fournisseurs (`jean.dupont@gmail.com` → `jeandupont@gmail.com`,
 * suppression des sous-adresses `+`, `googlemail.com` → `gmail.com`,
 * `yandex.ua` → `yandex.ru`). Les adresses déjà en base sont stockées sous leur
 * forme d'origine : les appliquer maintenant ne retrouverait plus les comptes
 * existants. On restreint donc la normalisation au passage en minuscules, seul
 * comportement historique.
 */
const LOWERCASE_ONLY_NORMALIZATION = {
  all_lowercase: true,
  gmail_remove_dots: false,
  gmail_remove_subaddress: false,
  gmail_convert_googlemaildotcom: false,
  outlookdotcom_remove_subaddress: false,
  yahoo_remove_subaddress: false,
  icloud_remove_subaddress: false,
  yandex_convert_yandexru: false,
}

/**
 * Règles serveur-only (`unique`, `exists`) à greffer sur le champ. Elles sont
 * appliquées après la normalisation, donc comparées à l'adresse normalisée.
 */
type EmailDatabaseRules = (field: VineString) => VineString

/**
 * Champ email unique du monorepo : valide (validator.js), normalise et produit
 * le type brandé `Email`. Utiliser `.optional()` / `.nullable()` au besoin.
 */
export const emailField = (databaseRules?: EmailDatabaseRules) => {
  const field = vine
    .string()
    .trim()
    .email()
    .maxLength(EMAIL_MAX_LENGTH)
    .normalizeEmail(LOWERCASE_ONLY_NORMALIZATION)

  return (databaseRules ? databaseRules(field) : field).transform(normalizeEmail)
}

export const lenientEmailField = () =>
  vine.string().trim().maxLength(EMAIL_MAX_LENGTH).transform(normalizeEmail)
